import { ShapeBaseAttribute } from './base';

export class ProgressBarAttribute extends ShapeBaseAttribute {
  /**
   * 进度条内环半径(百分比)
   * @deprecated
   */
  innerRingPercent = 20;

  /**
   * 进度条半径和弧长
   */
  barWidth?: number = 100;
  barRadius?: number = 20;

  /**
   * 指示器的旋转半径
   */
  indicatorRadius?: number;

  /**
   * 进度条端点类型
   */
  endingStyle: 'normal' | 'round' = 'normal';

  /**
   * 进度条类型
   */
  progressBarType: 'arc' | 'line' = 'arc';

  /**
   *进度条方向：posituve 顺时针 negative：逆时针
   */
  growDirection:
    | 'positive'
    | 'negative'
    | 'to-right'
    | 'to-left'
    | 'to-up'
    | 'to-down' = 'positive';

  pivotX?: number;
  pivotY?: number;

  resources: {
    bg?: LayerResourceItem;
    progress?: LayerResourceItem;
    /**
     * 指示器图片
     */
    indicatorImage?: LayerResourceItem;
    /**
     * ifttt无数据时显示的图片
     */
    iftttEmptyImage?: LayerResourceItem;
  } = {};

  // 透明度
  alpha?: number;
}
